// @flow
/* eslint-disable no-empty-function */
/* eslint-disable no-unused-vars */
import type { Observable, PureComputed } from 'rgs-knockout';

export type AnalyticsOptions = {
	productName: Observable | PureComputed | string,
};

export default class StepsAnalyticsHelper {

	_productName: Observable | PureComputed | string;
	sendOpenStepEvent: (stepId: number, duringWithAllClosed: boolean) => void;

	constructor (options: AnalyticsOptions) {
		this._productName = options.productName;
	}
	
	sendOpenStepEvent (
		stepID: number,
		duringWithAllClosed: boolean = false,
	): void {
		
	}
}
